import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface MarketRegionData {
  region: 'BR' | 'US';
  currency: 'BRL' | 'USD';
  loading: boolean;
  error: string | null;
}

export const useMarketRegion = (): MarketRegionData => {
  const { i18n } = useTranslation();
  
  const [data, setData] = useState<MarketRegionData>(() => {
    // Derive from i18n language (already detected via IP)
    const lang = i18n.language || localStorage.getItem('i18nextLng') || 'en-US';
    const region = lang === 'pt-BR' ? 'BR' : 'US';
    
    return {
      region,
      currency: region === 'BR' ? 'BRL' : 'USD',
      loading: false,
      error: null,
    };
  });

  // Update when i18n language changes
  useEffect(() => {
    const handleLanguageChange = (lang: string) => {
      const region = lang === 'pt-BR' ? 'BR' : 'US';
      console.log(`[MARKET-REGION] Language changed to ${lang}, region: ${region}`);
      
      setData({
        region,
        currency: region === 'BR' ? 'BRL' : 'USD',
        loading: false,
        error: null,
      });
    };

    // Listen to language changes
    i18n.on('languageChanged', handleLanguageChange);
    
    // Set initial value based on current language
    if (i18n.language) {
      handleLanguageChange(i18n.language);
    }

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return data;
};